const Dummy = () => {
  return <div>Hi</div>;
};

export default Dummy;
